<ng-container *ngIf="block">
    <div class="container-card d-flex flex-column justify-content-between no-print">
        <div>
            <div *ngIf="stringTaxonomies" class="container-card__category ls-label-small text-neutral-60 text-uppercase"
                [innerHTML]="stringTaxonomies"></div>
            <div class="container-card__title">
                <a *ngIf="!isLinkEsternal && objTitle.link" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
                    <h3 class="ls-h3-item-title text-brand-10 cursor-pointer" [innerHTML]="objTitle.title"></h3>
                </a>
                <a *ngIf="isLinkEsternal && objTitle.link" [href]="objTitle.link">
                    <h3 class="ls-h3-item-title text-brand-10 cursor-pointer" [innerHTML]="objTitle.title"></h3>
                </a>
            </div>
        </div>
        <div>
            <div class="container-card__info text-uppercase">
                <div class="text">
                    <p class="ls-label-small-semibold text-neutral-30 title">{{"BLOCK.SAMPLE_CARD_ALLOGGI.CITY" |
                        translate}}</p>
                    <p class="ls-label-small text-neutral-60" [innerHTML]="block.field_citta"></p>
                </div>
                <div class="text">
                    <p class="ls-label-small-semibold text-neutral-30 title">{{"BLOCK.SAMPLE_CARD_ALLOGGI.ADDRESS" |
                        translate}}</p>
                    <p class="ls-label-small text-neutral-60" [innerHTML]="block.field_indirizzo"></p>
                </div>
            </div>
            <a *ngIf="!isLinkEsternal && objTitle.link" [routerLink]="navigationService.splitUrlRouterLink(objTitle.link).path" [queryParams]="navigationService.splitUrlRouterLink(objTitle.link).queryParams">
                <div class="m-0 container-card__cta line-discover-with-icon">
                    <p class="ls-label-medium-semibold text-brand-40 text-uppercase"
                        [innerHTML]="'BLOCK.SAMPLE_CARD_ALLOGGI.FIND_OUT_MORE' | translate"></p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </a>
            <a *ngIf="isLinkEsternal && objTitle.link" [href]="objTitle.link">
                <div class="m-0 container-card__cta line-discover-with-icon">
                    <p class="ls-label-medium-semibold text-brand-40 text-uppercase"
                        [innerHTML]="'BLOCK.SAMPLE_CARD_ALLOGGI.FIND_OUT_MORE' | translate"></p>
                    <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
                </div>
            </a>
        </div>
    </div>
    <app-sample-print [taxonomy]="stringTaxonomies" [title]="objTitle.title"></app-sample-print>
</ng-container>